export const getSettingsState = state => state.settings;
export const getServicesState = state => state.settings.services;
export const getRatesState = state => state.settings.rates;
